/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHeroApiService } from '@core/hooks';
import { Button, Popover } from 'antd';
import { MIDDLE_STYLE } from '@constants/responsive';
import { useAppDispatch, useAuthState, useBusinessState } from '@core/configureStore';
import { fetchSquareMerchant } from '@core/features/business/thunks/fetchSquareMerchant.thunk';

type Props = {};

const ConnectSquareIntegrationButton = (props: Props) => {
  const { user } = useAuthState();
  const dispatch = useAppDispatch();
  const { integration } = useBusinessState();
  const [loading, setLoading] = useState<boolean>(false);
  const [mount, setMount] = useState<boolean>(false);
  const heroApiService = useHeroApiService();
  const handleConnect = async () => {
    const url = await heroApiService.squareOauthLogin();
    window.open(url);
  };

  const handleRefresh = async () => {
    if (!user) return;

    try {
      await dispatch(fetchSquareMerchant());
    } catch (error) {
      console.log(error);
    }
  };

  const handleLogoutSquare = async () => {
    if (!user) return;
    setLoading(true);
    try {
      await heroApiService.unintegrateSquareFromLocation();
      await handleRefresh();
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      setMount(false);
      await handleRefresh();
      setMount(true);
      setLoading(false);
    };
    init();
  }, []);

  return mount && integration.square ? (
    <Popover trigger={'click'} content={<Button onClick={handleLogoutSquare}>Log out</Button>}>
      <Button loading={loading} style={{ ...MIDDLE_STYLE }}>
        <img alt="Square" src="square-inc.png" width={25} height={25} style={{ marginRight: 10 }} />{' '}
        {integration.square?.businessName} ({integration.square.country})
      </Button>
    </Popover>
  ) : (
    <Button loading={loading} onClick={handleConnect} style={{ ...MIDDLE_STYLE }}>
      <img alt="Square" src="square-inc.png" width={25} height={25} style={{ marginRight: 10 }} />{' '}
      Connect to Square
    </Button>
  );
};

export default ConnectSquareIntegrationButton;
